var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{staticClass:"d-none d-sm-flex"},_vm._l((_vm.menuItems),function(item){return _c('v-tab',{key:item.name,attrs:{"to":item.url}},[_vm._v(_vm._s(item.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }